export default "__VITE_ASSET__bU666vFC__"